"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchOptions = void 0;
const typeguards_1 = require("./typeguards");
function searchOptions(options, search, enableGroupSearch) {
    if (search === '') {
        return options;
    }
    const searchLowerCase = search.toLowerCase();
    return options.filter(option => {
        const optionTextLowerCase = option.text.toLowerCase();
        const isTextMatch = optionTextLowerCase.includes(searchLowerCase);
        if (enableGroupSearch && typeguards_1.isOptionWithGroup(option)) {
            const optionGroupLowerCase = String(option.group).toLowerCase();
            const isGroupMatch = optionGroupLowerCase.includes(searchLowerCase);
            return isGroupMatch || isTextMatch;
        }
        return isTextMatch;
    });
}
exports.searchOptions = searchOptions;
//# sourceMappingURL=searchOptions.js.map